import { render, staticRenderFns } from "./AnnualAccountsReceivable.vue?vue&type=template&id=49fadf7a&scoped=true"
import script from "./AnnualAccountsReceivable.vue?vue&type=script&lang=js"
export * from "./AnnualAccountsReceivable.vue?vue&type=script&lang=js"
import style0 from "./AnnualAccountsReceivable.vue?vue&type=style&index=0&id=49fadf7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fadf7a",
  null
  
)

export default component.exports